<template>
  <!--  <div class="main">-->
  <div class="main" :style="{ minHeight: mainHeight }">
    <div v-if="step === 1" class="blocks f-c-c fc">
      <div class="f-c-c">
        <el-image
          :src="handImg"
          style="height: 42px;margin-right: -10px;z-index: 99"
          fit="contain"
        ></el-image>

        <div
          class="blockBtn notScale"
          style="width: 130px;padding: 12px 8px"
          @click="$router.push({ path: '/shine', query: { flag: 2 } })"
        >
          Historical records
        </div>
      </div>

      <el-form
        v-loading="sb"
        element-loading-background="rgba(218, 226, 126, .6)"
        :show-message="false"
        class="formBlock"
        :rules="dataRule"
        ref="form"
        :model="formData"
        label-position="left"
      >
        <div style="width: 100%;margin-bottom: 15px;">
          <div style="color:#492500">Pipeline name:</div>
          <el-form-item prop="name">
            <el-input
              class="customInp-small"
              v-model="formData.name"
            ></el-input>
          </el-form-item>
        </div>

        <!--<div>-->
        <!--<div style="color:#492500">Target Genus:</div>-->
        <!--<el-form-item prop="genus">-->
        <!--&lt;!&ndash;            <el-input class="customInp-small" v-model="formData.genus"></el-input>&ndash;&gt;-->
        <!--<el-select class="customInp-small w100" @change="genusChangeHandle"-->
        <!--v-model="formData.genus" placeholder=" " allow-create filterable>-->
        <!--<el-option-->
        <!--v-for="item in genusOptions"-->
        <!--:key="item.value"-->
        <!--:label="item.label"-->
        <!--:value="item.value">-->
        <!--</el-option>-->
        <!--</el-select>-->
        <!--</el-form-item>-->
        <!--</div>-->

        <div>
          <div style="color:#492500">
            Target Specis/Target Subspecies:<br /><span
              style="color: #492500;font-size: 11px;"
              >(Example: Target Specis>Target Subspecies)</span
            >
          </div>
          <div
            class="f-b-l"
            v-for="(item, index) in formData.targetStrainList"
            :key="index"
          >
            <el-form-item>
              <!--              <el-input class="customInp-small" v-model="formData.targetStrainList[index]['species']"></el-input>-->
              <!--            <el-row v-for="(strain, index) in formData.targetStrainList" :key="strain.key" :class="index !==0 ? 'row':''">-->
              <!--              <el-form-item label-width="0px" :prop="'targetStrainList.' + index + '.species'"-->
              <!--                            :rules="{required: true, message: '种不能为空', trigger: 'change'}">-->
              <el-select
                class="customInp-small"
                allow-create
                filterable
                @change="val => changeTargetStrain(index, val)"
                style="width: 100%"
                v-model="formData.targetStrainList[index]['combination']"
                placeholder=" "
              >
                <el-option
                  v-for="item in index === 0
                    ? targetSpeciesOptions
                    : contrastSpeciesOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <!--              </el-form-item>-->
              <!--            </el-row>-->
            </el-form-item>
            <i
              class="el-icon-circle-plus"
              @click="formData.targetStrainList.push({ combination: '' })"
              v-if="index === 0"
              style="padding:12px 0 0 10px;font-size: 21px;cursor: pointer;color:#939d31"
            ></i>
            <i
              class="el-icon-error"
              @click="formData.targetStrainList.splice(index, 1)"
              v-else
              style="padding:12px 0 0 10px;font-size: 21px;cursor: pointer;color:#939d31"
            ></i>
          </div>
        </div>

        <div>
          <div style="color:#492500">
            Comparison organisms:<br /><span
              style="color: #492500;font-size: 11px;"
              >(Example: Target Specis>Target Subspecies)</span
            >
          </div>
          <div
            class="f-b-l"
            v-for="(item, index) in formData.contrastStrainList"
            :key="index"
          >
            <el-form-item>
              <!--              <el-input class="customInp-small" v-model="formData.contrastStrainList[index]['species']"></el-input>-->
              <!--              <el-input class="customInp-small" v-model="formData.contrastStr"></el-input>-->
              <!--            <el-row v-for="(strain, index) in formData.contrastStrainList" :key="strain.key" :class="index !==0 ? 'row':''">-->
              <!--              <el-form-item label-width="0px" :prop="'contrastStrainList.' + index + '.species'"-->
              <!--                            :rules="{required: true, message: '种不能为空', trigger: 'change'}">-->
              <el-select
                class="customInp-small"
                allow-create
                filterable
                v-model="formData.contrastStrainList[index]['combination']"
                placeholder=" "
                style="width: 100%"
              >
                <el-option
                  v-for="item in contrastSpeciesOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <!--              </el-form-item>-->
              <!--            </el-row>-->
            </el-form-item>
            <i
              class="el-icon-circle-plus"
              @click="formData.contrastStrainList.push({ combination: '' })"
              v-if="index === 0"
              style="padding:12px 0 0 10px;font-size: 21px;cursor: pointer;color:#939d31"
            ></i>
            <i
              class="el-icon-error"
              @click="formData.contrastStrainList.splice(index, 1)"
              v-else
              style="padding:12px 0 0 10px;font-size: 21px;cursor: pointer;color:#939d31"
            ></i>
          </div>
        </div>

        <div class="f-l-c" style="margin: 10px 0px 15px 10px">
          <div class="greenTitle" style="min-width: 210px">
            Uploaded local fasta files:
          </div>
          &nbsp;&nbsp;
          <el-form-item style="margin-bottom: 0px;" prop="isFile">
            <el-switch
              v-model="formData.isFile"
              active-color="#939D31"
              inactive-color="gray"
            >
            </el-switch>
          </el-form-item>
        </div>

        <div class="moreForm w100 f-c-c" v-if="formData.isFile">
          <div class="f-b-c fc w100">
            <div class="f-b-c w100">
              <!--              <div class="f-l-c">-->
              <!--                <div style="width: 65px">Type:</div>-->
              <!--                <el-form-item prop="uploadType" :rules="[-->
              <!--                  { required: true, message: 'Please select file type', trigger: 'blur' },-->
              <!--                ]">-->
              <!--                  <el-select class="customInp-small" placeholder=" " v-model="formData.uploadType">-->
              <!--                    <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
              <!--                  </el-select>-->
              <!--                </el-form-item>-->
              <!--              </div>-->
              <!--              <br />-->
              <div class="f-l-l fc">
                <div class="mb10">Target Species file:</div>
                <el-upload
                  ref="inputFile"
                  drag
                  :data="{ ...uploadForm, type: 0 }"
                  :action="uploadPath"
                  :on-remove="
                    (file, fileList) => removeHandle(file, fileList, 'fileList')
                  "
                  :on-change="
                    (file, fileList) => changeHandle(file, fileList, 'fileList')
                  "
                  :before-upload="beforeUploadHandle"
                  :on-success="
                    (response, file, fileList) =>
                      successHandle(response, file, fileList, 'fileList')
                  "
                  :multiple="false"
                  :limit="1"
                  accept=".zip,.ZIP,.rar,.RAR,.tar,.TAR"
                  :file-list="fileList"
                  :auto-upload="false"
                >
                  <i class="el-icon-upload" style="color:#6F7B08"></i>
                  <div
                    class="el-upload__text"
                    style="color:#492500;font-size: 12px;line-height: 20px"
                  >
                    Drag and drop files,<br />
                    you can add as an attachment(100Mb, zip or rar or tar)
                  </div>
                </el-upload>
              </div>
              <div class="f-l-l fc">
                <div class="mb10">Comparison organisms file:</div>
                <el-upload
                  ref="inputFile2"
                  drag
                  :data="{ ...uploadForm, type: 1 }"
                  :action="uploadPath"
                  :on-remove="
                    (file, fileList) =>
                      removeHandle(file, fileList, 'fileList2')
                  "
                  :on-change="
                    (file, fileList) =>
                      changeHandle(file, fileList, 'fileList2')
                  "
                  :before-upload="beforeUploadHandle"
                  :on-success="
                    (response, file, fileList) =>
                      successHandle(response, file, fileList, 'fileList2')
                  "
                  :multiple="false"
                  :limit="1"
                  accept=".zip,.ZIP,.rar,.RAR,.tar,.TAR"
                  :file-list="fileList2"
                  :auto-upload="false"
                >
                  <i class="el-icon-upload" style="color:#6F7B08"></i>
                  <div
                    class="el-upload__text"
                    style="color:#492500;font-size: 12px;line-height: 20px"
                  >
                    Drag and drop files,<br />
                    you can add as an attachment(100Mb, zip or rar or tar)
                  </div>
                </el-upload>
              </div>

              <!--              <div class="f-c-c">-->
              <!--                <div class="blockBtn" style="width: 130px;margin: 40px 0px 30px 65px">-->
              <!--                  Finished-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
          </div>
        </div>

        <div class="moreForm">
          <div class="f-l-c">
            <el-form-item prop="targetFragmentLength">
              <label style="min-width: 180px"
                >Target fragment length: &gt;</label
              >
              <el-input-number
                class="customInp-small w100 mr10"
                v-model="formData.targetFragmentLength"
                :controls="false"
                :precision="0"
              ></el-input-number>
              <label>bp</label>
            </el-form-item>
          </div>

          <div class="f-l-c">
            <el-form-item prop="repeatSimilarity">
              <label style="min-width: 210px"
                >Repeated region similarity: &gt;</label
              >
              <el-input-number
                class="customInp-small w100 mr10"
                v-model="formData.repeatSimilarity"
                :controls="false"
                :precision="1"
              ></el-input-number>
              <label>%</label>
            </el-form-item>
          </div>

          <div class="f-l-c">
            <el-form-item prop="specificity">
              <label style="min-width: 160px">Species specificity: &lt;</label>
              <el-input-number
                class="customInp-small w100 mr10"
                v-model="formData.specificity"
                :controls="false"
                :precision="1"
              ></el-input-number>
              <label>%</label>
            </el-form-item>
          </div>

          <div class="f-l-c">
            <el-form-item prop="distribution">
              <label style="min-width: 260px"
                >Target fragment strain distribution: &lt;</label
              >
              <el-input-number
                class="customInp-small w100 mr10"
                v-model="formData.distribution"
                :controls="false"
                :precision="1"
              ></el-input-number>
              <label>%</label>
            </el-form-item>
          </div>

          <div class="w100 mt10">
            <div class="greenTitle">Host sequence filtering:</div>
            <el-form-item prop="hostSequence">
              <el-checkbox-group v-model="formData.hostSequence">
                <el-checkbox label="No filtering"></el-checkbox>
                <el-checkbox label="Home sapiens"></el-checkbox>
                <el-checkbox label="Chicken"></el-checkbox>
                <el-checkbox label="Swine"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>

          <div class="w100 mt10">
            <div class="greenTitle mb10">Priority scheme:</div>

            <el-form-item prop="priorityScheme">
              <el-select
                class="customInp-small"
                placeholder="select Priority scheme"
                v-model="formData.priorityScheme"
                style="width: 320px"
              >
                <el-option
                  v-for="item in schemeList"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>

            <div class="f-l-c">
              <el-form-item prop="similarityThreshold">
                <!--                Calculation of target strain and alarm threshold similarities: &gt;-->
                Alarm threshold for similarities between target strains against
                with heterogeneity: &gt;
                <el-input-number
                  class="customInp-small mr10"
                  style="width: 180px;margin: 0 10px"
                  v-model="formData.similarityThreshold"
                  :controls="false"
                  :precision="0"
                ></el-input-number
                >%
              </el-form-item>
            </div>
          </div>

          <div class="w100 mt10">
            <div class="greenTitle mb10">Primer probe design parameters:</div>

            <el-radio v-model="formData.settings" label="Default settings"
              >Default settings</el-radio
            >
            <el-radio v-model="formData.settings" label="Customize settings"
              >Customize settings</el-radio
            >
          </div>
        </div>

        <div class="w100 extForm">
          <div class="f-l-c">
            <el-form-item
              label="Primers Length:"
              label-width="115px"
              prop="primersLengthBegin"
            >
              <el-input-number
                class="customInp-small w100 mr10"
                v-model="formData.primersLengthBegin"
                :controls="false"
                :precision="0"
                :disabled="formData.settings === 'Default settings'"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="TO:"
              label-width="40px"
              prop="primersLengthEnd"
            >
              <el-input-number
                class="customInp-small w100 mr10"
                v-model="formData.primersLengthEnd"
                :controls="false"
                :precision="0"
                :disabled="formData.settings === 'Default settings'"
              ></el-input-number>
            </el-form-item>
            <div>bp</div>
          </div>

          <div class="f-l-c">
            <el-form-item
              label="Primers Tm:"
              label-width="95px"
              prop="primersTm"
            >
              <el-input-number
                class="customInp-small w100 mr10"
                v-model="formData.primersTm"
                :controls="false"
                :precision="1"
                :disabled="formData.settings === 'Default settings'"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="+ / -"
              label-width="40px"
              prop="primersTmRange"
            >
              <el-input-number
                class="customInp-small w100 mr10"
                v-model="formData.primersTmRange"
                :controls="false"
                :precision="1"
                :disabled="formData.settings === 'Default settings'"
              ></el-input-number>
            </el-form-item>
            <div>℃</div>
          </div>

          <div class="f-l-c">
            <el-form-item
              label="Amplicon Length:"
              label-width="125px"
              prop="ampliconLengthBegin"
            >
              <el-input-number
                class="customInp-small w100 mr10"
                v-model="formData.ampliconLengthBegin"
                :controls="false"
                :precision="0"
                :disabled="formData.settings === 'Default settings'"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="TO:"
              label-width="40px"
              prop="ampliconLengthEnd"
            >
              <el-input-number
                class="customInp-small w100 mr10"
                v-model="formData.ampliconLengthEnd"
                :controls="false"
                :precision="0"
                :disabled="formData.settings === 'Default settings'"
              ></el-input-number>
            </el-form-item>
            <div>bp</div>
          </div>

          <div class="f-l-c">
            <el-form-item
              label="Probe Length:"
              label-width="110px"
              prop="probeLengthBegin"
            >
              <el-input-number
                class="customInp-small w100 mr10"
                v-model="formData.probeLengthBegin"
                :controls="false"
                :precision="0"
                :disabled="formData.settings === 'Default settings'"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="TO:" label-width="40px" prop="probeLengthEnd">
              <el-input-number
                class="customInp-small w100 mr10"
                v-model="formData.probeLengthEnd"
                :controls="false"
                :precision="0"
                :disabled="formData.settings === 'Default settings'"
              ></el-input-number>
            </el-form-item>
            <div>bp</div>
          </div>

          <div class="f-l-c">
            <el-form-item
              label="Probe Tm: Primer Tm +"
              label-width="160px"
              prop="probeTm"
            >
              <el-input-number
                class="customInp-small w100 mr10"
                v-model="formData.probeTm"
                :controls="false"
                :precision="1"
                :disabled="formData.settings === 'Default settings'"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="+ / -" label-width="40px" prop="probeTmRange">
              <el-input-number
                class="customInp-small w100 mr10"
                v-model="formData.probeTmRange"
                :controls="false"
                :precision="1"
                :disabled="formData.settings === 'Default settings'"
              ></el-input-number>
            </el-form-item>
            <div>℃</div>
          </div>

          <div class="mtb10" style="color:#492500;font-size: 15px">
            Note: please use the semicolon to separate them.
          </div>

          <div
            class="f-c-c"
            style="position: absolute;margin: auto;left:0px;right: 0px"
          >
            <div
              class="blockBtn mlr10"
              :class="{ 'custom-disabled': !!sb }"
              @click="!!sb ? null : resetForm()"
            >
              Reset
            </div>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <div
              class="blockBtn mlr10"
              :class="{ 'custom-disabled': !!sb }"
              @click="!!sb ? null : submitForm()"
            >
              Submit
            </div>
          </div>
        </div>
      </el-form>

      <div class="f-c-c fc" style="padding-top: 50px; color:white">
        <!--        <div class="customBtn mtb10" @click="$router.push('feedback')">Licence Support!</div>-->
        <div class="mtb10 hover-pointer" @click="$router.push('feedback')">
          If you experience any difficulties or have questions about Shine,
          please reach out to us at feedback.
        </div>
      </div>
    </div>

    <div v-else-if="step === 2" class="blocks">
      <div class="blockTitle">Work management</div>
      <div class="block">
        <div class="mb10" style="width: 250px">
          <el-input
            v-model="filterKey"
            class="customInp-small white"
            size="small"
            suffix-icon="el-icon-search"
            placeholder="Search"
            @keydown.13.native="getDataList"
          ></el-input>
        </div>
        <el-table
          border
          :data="dataList"
          empty-text="No data"
          :header-cell-style="{ color: '#4C2A02', fontSize: '13px' }"
        >
          <el-table-column
            prop="createUserName"
            align="center"
            label="user name"
          >
          </el-table-column>
          <el-table-column
            prop="id"
            align="center"
            width="120"
            label="serial number"
          >
          </el-table-column>
          <el-table-column prop="name" align="center" label="entry name">
          </el-table-column>
          <!--          <el-table-column-->
          <!--            prop="status"-->
          <!--            align="center"-->
          <!--            width="120"-->
          <!--            label="transfer status">-->
          <!--            <template slot-scope="scope">-->
          <!--              <div style="padding: 5px">-->
          <!--                <el-progress :percentage="(+scope.row.status + 1) * 20" :text-inside="true" :stroke-width="18" :color="customColors"></el-progress>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column
            prop="percentage"
            align="center"
            width="180"
            label="the operation schedule"
          >
            <template slot-scope="scope">
              <div style="padding: 5px">
                <el-tag
                  v-if="scope.row.status === '2'"
                  size="small"
                  type="warning"
                  >Waiting for the calculation</el-tag
                >
                <el-progress
                  :width="80"
                  v-if="scope.row.status === '3'"
                  :text-inside="true"
                  :stroke-width="16"
                  :percentage="+scope.row.percentage"
                  :color="customColors"
                ></el-progress>
                <el-progress
                  :width="80"
                  v-if="scope.row.status === '4'"
                  :text-inside="true"
                  :stroke-width="16"
                  :percentage="100"
                  :color="customColors"
                ></el-progress>
                <!--                <el-progress :percentage="100" :show-text="false"></el-progress>-->
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="down" align="center" label="Download">
            <template slot-scope="scope">
              <div class="f-c-c ptb10">
                <i
                  class="el-icon-bottom tableIcon"
                  @click="downloadHandle(scope.row)"
                ></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" align="center" label="create time">
          </el-table-column>
          <el-table-column prop="operation" align="center" label="operation">
            <template slot-scope="scope">
              <div class="f-c-c ptb10">
                <i
                  class="el-icon-minus tableIcon"
                  @click="deleteHandle(scope.row)"
                ></i>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="f-r-c mt10">
          <!--          @size-change="handleSizeChange"-->
          <!--          @current-change="handleCurrentChange"-->
          <!--          :current-page.sync="currentPage3"-->
          <el-pagination
            :background="true"
            :small="true"
            :hide-on-single-page="false"
            :page-size="paginations.size"
            :current-page.sync="paginations.page"
            @current-change="page => (paginations.page = page)"
            layout="prev, pager, next, jumper"
            :total="paginations.total"
          >
            <slot class="pageSizeInput">
              <el-input class="pageSizeBorder"></el-input> 条/页
            </slot>
          </el-pagination>
        </div>

        <!--        <div class="f-r-c mt10">-->
        <!--          <i class="el-icon-arrow-left tableIcon"></i>-->
        <!--          <div>Page</div>-->
        <!--          <el-input class="customInp-mini" style="width: 50px;margin:0 5px;text-align: center"></el-input>-->
        <!--          <div>of {{3}}</div>-->
        <!--          <i class="el-icon-arrow-right tableIcon"></i>-->

        <!--        </div>-->
      </div>
    </div>

    <div v-else class="blocks">
      <div class="blockTitle">
        <div class="b-title">Welcome to</div>
        <div>the homepage of Shine</div>
      </div>
      <div class="block b-content">
        <div class="listBlock">
          <div v-for="item in list" :key="item.key" class="f-l-c">
            <div style="width: 12px;text-align: center">{{ item.key }}</div>
            <div style="width: 5px">:</div>
            &nbsp;&nbsp;
            <span @click="actListItemKey = item.key">{{ item.code }}</span>
          </div>
        </div>

        <el-image
          :src="treeImg"
          style="height: 520px;top: -515px;left: 21%"
        ></el-image>

        <div style="top: -940px;right: -64%;text-align: center">
          <div class="f-c-c resTabIcon">
            {{ actListItemKey }}
          </div>

          <div class="resTabTitle">
            {{ actListItem.code }}
          </div>
          <div class="resTabContent">
            <div
              v-for="item in actListItem.child"
              :key="item"
              style="color: #221815"
            >
              <div>-&nbsp;&nbsp;</div>
              <div>{{ item }}</div>
            </div>
          </div>
        </div>

        <div
          class="blockBtn"
          style="width: 65px;top:-920px;left: 75%"
          @click="toForm"
        >
          Let's go!
        </div>
      </div>

      <div style="height: 15px"></div>

      <div class="blockTitle" style="font-size: 20px">Overview</div>
      <div class="block" style="color: #212121;">
        <div class="abstract">
<!--          <div class="title">-->
<!--            Abstract-->
<!--          </div>-->

          <div class="abstract-content selected" id="eng-abstract">
            <p>
              <strong class="sub-title">
                Background:
              </strong>

              Concentrations of the pathogenic microorganisms' DNA in biological
              samples are typically low. Therefore, DNA diagnostics of common
              infections are costly, rarely accurate, and challenging. Limited
              by failing to cover updated epidemic testing samples,
              computational services are difficult to implement in clinical
              applications without complex customized settings. Furthermore, the
              combined biomarkers used to maintain high conservation may not be
              cost effective and could cause several experimental errors in many
              clinical settings. Given the limitations of recent developed
              technology, 16S rRNA is too conserved to distinguish closely
              related species, and mosaic plasmids are not effective as well
              because of their uneven distribution across prokaryotic taxa.
            </p>

            <p>
              <strong class="sub-title">
                Results:
              </strong>

              Here, we provide a computational strategy, Shine, that allows
              extraction of specific, sensitive and well-conserved biomarkers
              from massive microbial genomic datasets. Distinguished with simple
              concatenations with blast-based filtering, our method involves a
              de novo genome alignment-based pipeline to explore the original
              and specific repetitive biomarkers in the defined population. It
              can cover all members to detect newly discovered multicopy
              conserved species-specific or even subspecies-specific target
              probes and primer sets. The method has been successfully applied
              to a number of clinical projects and has the overwhelming
              advantages of automated detection of all pathogenic microorganisms
              without the limitations of genome annotation and incompletely
              assembled motifs. Using on our pipeline, users may select
              different configuration parameters depending on the purpose of the
              project for routine clinical detection practices on the website
              https://bioinfo.liferiver.com.cn with easy registration.
            </p>

            <p>
              <strong class="sub-title">
                Conclusions:
              </strong>

              The proposed strategy is suitable for identifying shared
              phylogenetic markers while featuring low rates of false positive
              or false negative. This technology is suitable for the automatic
              design of minimal and efficient PCR primers and other types of
              detection probes.
            </p>
          </div>

          <p>
            <strong class="sub-title">
              Keywords:
            </strong>

            Biomarker; Conservation; Microbial genome; Sensitivity; Specificity.
          </p>
        </div>
        <br /><b>Citing this software</b> <br />
        Ji, C., & Shao, J. (2023). Shine: A novel strategy to extract specific,
        sensitive and well-conserved biomarkers from massive microbial genomic
        datasets. BMC bioinformatics, 24(1), 128.
        <a href="https://doi.org/10.1186/s12859-023-05195-2" target="_blank"
          >https://doi.org/10.1186/s12859-023-05195-2</a
        >
      </div>
      <br />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { getGenus, getSpecies } from "@/utils/strain";
import { targetList } from "@/utils/index";

export default {
  name: "shine",
  data() {
    return {
      handImg: require("../../static/img/hand.png"),
      starImg: require("../../static/img/star.png"),
      treeImg: require("../../static/img/tree.png"),
      mainHeight: 0,
      step: 0,
      sb: false,
      list: [
        {
          key: "A",
          code: "Influenza",
          child: [
            "Influenza A virus",
            "Influenza B virus (Victoria)",
            "Influenza B virus (Yamagata)",
            "Influenza A virus H1/H2/H3/H4/H5",
            "Influenza A virus H6/H7/H8/H9/H10",
            "Influenza A virus H11/H12/H14/H15",
            "Influenza A virus H1 (2009)/H16/N6",
            "Influenza A virus N1/N2/N3/N4/N5",
            "G4 EA H1N1",
            "Influenza A virus H3N8/H3N2/H9N2",
            "Influenza A virus H1N1/H5N6/H7N9",
            "Influenza A virus H3N2/H9N2/H1N1",
            "Influenza A virus H5N1/H5N2/H5N7"
          ]
        },
        {
          key: "B",
          code: "Coronavirus",
          child: [
            "Human coronavirus HKU1",
            "Human coronavirus OC43",
            "Human coronavirus NL63",
            "Human coronavirus 229E",
            "MERS-CoV",
            "SARS-CoV",
            "SARS-CoV-2",
            "SADS-CoV",
            "Rhinolophus Bat coronavirus HKU2",
            "Pipistrellus bat coronavirus HKU5",
            "Tylonycteris bat coronavirus HKU4",
            "Rousettus bat coronavirus HKU9",
            "Bat SARS coronavirus HKU3"
          ]
        },
        {
          key: "C",
          code: "Gastrointestinal",
          child: [
            "Enterovirus /A71",
            "Coxsackievirus A16/A6/A10/A24",
            "Echovirus E11/E30",
            "Enteroadenovirus",
            "Sapovirus 1/2",
            "Human astrovirus",
            "Severe Fever with Thrombocytopenia Syndrome",
            "Norovirus G1.1/G1.2/G2",
            "Measles virus",
            "Poliovirus/1/2/3",
            "Hepatitis A virus",
            "Hepatitis B virus",
            "Picobirnavirus",
            "Yersinia enterocolitica",
            "Listeria monocytogenes",
            "Shigella Castellani",
            "Salmonella typhi",
            "Salmonella enterica paratyphoidfever",
            "Vibrio parahaemolyticus",
            "Pseudomonas aeruginosa",
            "Campylobacter jejuni",
            "Intestinal staphylococcus aureus",
            "Aeromonas hydrophila",
            "Plesiomonas shigelloides",
            "Clostridium perfringens",
            "Cholera Vibrio cholerae",
            "Vibrio paracholerae",
            "Vibrio vulnificus",
            "Campylobacter (jejuni, coli, and upsaliensis)",
            "Clostridium difficile",
            "Clostridium botulinum",
            "Enterobacter sakazakii",
            "Bacillus cereus",
            "Proteus",
            "Candida Albicans",
            "Cryptosporidium",
            "Giardia lamblia",
            "Entamoeba histolytica Schaudinn",
            "Cyclospora",
            "Trichomona-didae",
            "Blastocystis hominis",
            "Helicobacter pylori",
            "Human parechovirus"
          ]
        },
        {
          key: "D",
          code: "Plasmodium",
          child: [
            "Plasmodium",
            "Plasmodium falciparum Welch",
            "Plasmodium vivax Grassi &amp; Feletti",
            "Plasmodium ovale Stephens",
            "Plasmodium malariae Laveran",
            "Plasmodium Knowlesi"
          ]
        },
        {
          key: "E",
          code: "Probiotics",
          child: [
            "Clostridium butyricum",
            "Bifidobacterium animalis subsp. Lactis",
            "Streptococcus thermophilus",
            "Streptococcus faecium",
            "Lactobacillus acidophilus",
            "Bacillus subtilis",
            "Bacteroides",
            "Prevotella",
            "Ruminococcus"
          ]
        },
        {
          key: "F",
          code: "Stockbreeding",
          child: [
            "Gallid alphaherpesvirus 1/2/3",
            "African swine fever virus",
            "Foot-and-mouth disease virus",
            "Rabies lyssavirus",
            "Porcine circovirus",
            "Senecavirus",
            "Brucella",
            "Porcine parvovirus",
            "Pseudorabies virus",
            "Japanese encephalitis",
            "Porcine respiratory and reproductive syndrome virus",
            "Canine distemper",
            "Canine Parvovirus",
            "Canine coronavirus",
            "Toxoplasma Gondii",
            "Influenza A virus H5",
            "Influenza A virus H5N2",
            "Influenza A virus H5N7",
            "Influenza A virus H7N9",
            "Influenza A virus N9",
            "Influenza A virus N8",
            "Influenza A virus N10",
            "Classical Swine Fever",
            "Infection with Mycoplasma mycoides subsp. mycoides",
            "Peste des petits ruminants virus",
            "Lumpy skin disease virus",
            "Sheep pox virus",
            "Capripoxvirus",
            "Rift Valley fever VHF Diseases",
            "Pasteurella multocida",
            "Avibirnavirus Infectious bursal disease virus",
            "Foot-and-mouth disease virus/O/A/SAT2/Asia1/SAT1/C/SAT3/A/O",
            "Newcastle disease virus",
            "Vesicular Stomatitis Virus",
            "Taura syndrome virus",
            "Yellow head virus",
            "White spot syndrome virus",
            "Infectious hypodermal and hematopoietic necrosis virus",
            "Penaeid shrimp infectious myonecrosis virus",
            "Leptospira",
            "Toxoplasma Gondii",
            "Monkeypox virus",
            "Trypanosoma equiperdum",
            "Dirofilaria immitis",
            "Bartonella henselae",
            "Bartonella",
            "Canine Parainfluenza Virus",
            "Canine adenovirus type-1/2",
            "Equine infectious anemia virus",
            "Eperythrozoon Mycoplasma",
            "Swine dysentery treponema hyodysenteriae",
            "Porcine cytomegalovirus",
            "Feline Coronavirus",
            "Encephalomyocarditis virus",
            "Nidovirales",
            "Alpharetrovirus",
            "Avian infectious bronchitis virus",
            "Bovine Viral Diarrhea Virus",
            "Bovine leukemiavirus",
            "Ehrlichia",
            "Nipah henipavirus"
          ]
        },
        {
          key: "G",
          code: "Respiratory tract",
          child: [
            "Parainfluenza/1/2/3/4/5",
            "Respiratory syncytial virus /A/B",
            "Adenovirus",
            "Mycobacterium tuberculosis",
            "Mycobacterium avium complex",
            "Bordetella pertussis",
            "Bordetella parapertussis",
            "Methicillin-resistant Staphylococcus aureus (MRSA)",
            "Legionella pneumophila",
            "Mycoplasma pneumoniae",
            "Chlamydia pneumoniae",
            "Acinetobacter baumannii",
            "Pseudomonas aeruginosa",
            "Haemophilus influenzae",
            "Klebsiella pneumoniae",
            "Klebsiella aerogenes",
            "Klebsiella oxytoca",
            "Moraxella catarrhalis",
            "Rhinovirus",
            "Human Metapneumovirus",
            "Enterobacter cloacae complex",
            "Escherichia coli",
            "Proteus",
            "Serratia marcescens",
            "Measles virus",
            "Rubella virus",
            "Mumps virus",
            "Human bocavirus",
            "Group A streptococcus",
            "Streptococcus pneumoniae",
            "Enterococcus",
            "Yersinia pestis",
            "Nipah henipavirus",
            "Enterovirus A71/A70"
          ]
        },
        {
          key: "H",
          code: "Hemorrhagic fever",
          child: [
            "Ebola virus",
            "Crimean-Congo hemorrhagic fever orthonairovirus",
            "Lymphocytic choriomeningitis virus Arenaviral hemorrhagic fever",
            "Lassa mammarenavirus",
            "Black Creek Canal virus",
            "Hantaan orthohantavirus",
            "Dobrava-Belgrade orthohantavirus",
            "Saaremaa virus",
            "Seoul orthohantavirus",
            "Puumala orthohantavirus",
            "Kyasanur Forest disease virus",
            "Lujo mammarenavirus",
            "Marburg virus",
            "Omsk hemorrhagic fever virus",
            "Rift Valley fever virus",
            "Brazilian mammarenavirus",
            "Tick-borne encephalitis virus",
            "Guanarito mammarenavirus",
            "Junin virus",
            "Machupo virus",
            "Flexal virus",
            "Tacaribe virus",
            "Whitewater Arroyo virus"
          ]
        },
        {
          key: "I",
          code: "Tick fever",
          child: [
            "Dengue virus 1/2/3/4",
            "Zika",
            "Chikungunya",
            "Yellow fever",
            "Hantaan virus",
            "Seoul virus",
            "Puumala virus",
            "Dobrava virus",
            "Sin Nombre orthohantavirus",
            "Black Creek Canalvirus",
            "Bayou virus",
            "Andes virus",
            "Prospect Hill virus",
            "Thailand virus",
            "Tula virus",
            "New York virus ",
            "Thottopalayam virus",
            "Semliki Forest virus",
            "Powassan virus",
            "Rocky Mountain spotted fever",
            "Colorado tick fever coltivirus",
            "Borrelia burgdorferi",
            "Borrelia duttoni",
            "Borrelia recurrentis",
            "Borrelia miyamotoi",
            "Coxiella burnetii",
            "Rickettsia sibirica",
            "Anaplasma marginale",
            "Ehrlichiosis",
            "Human granulocytic anaplasmosis",
            "Babesiosis",
            "Yersinia pestis",
            "Brucella",
            "Francisella tularensis",
            "West Nile Virus",
            "Toscana virus",
            "Rickettsia prowazekii",
            "Rickettsia mooseri",
            "Anaplasma phagocytophilum",
            "Severe Fever with Thrombocytopenia Syndrome"
          ]
        },
        {
          key: "J",
          code: "Rotavirus",
          child: [
            "Rotavirus A /G1/G2/G3/G4/G8/G9/P4/P6/P8",
            "Rotavirus B",
            "Rotavirus C",
            "Rotavirus D",
            "Rotavirus F",
            "Rotavirus G",
            "Rotavirus H",
            "Rotavirus I",
            "Rotavirus J",
            "Rotavirus K",
            "Rotavirus L"
          ]
        },
        {
          key: "K",
          code: "Fungi",
          child: [
            "Cryptoccus neoformans",
            "Candida auris",
            "Aspergillus fumigatus",
            "Candida Albicans",
            "Mucorales",
            "Fusarium",
            "Candida parapsilosis",
            "Scedosporium",
            "Coccidioides",
            "Candida krusei",
            "Cryptococcus gattii",
            "Talaromyces marneffei",
            "Pnuemocystis carinii",
            "Paracoccidioides"
          ]
        },
        {
          key: "L",
          code: "TORCH",
          child: [
            "Toxoplasma Gondii",
            "Rubella virus",
            "Human cytomegalovirus",
            "Treponema pallidum",
            "Neisseria gonorrhoeae",
            "Ureaplasma urealyticum",
            "Mycoplasma Genitalium",
            "Mycoplasma hominis",
            "Chlamydia trachomatis",
            "Chlamydia psittaci",
            "Human papilloma virus 6/11",
            "Human parvovirus B19",
            "Coxsackievirus",
            "Hepatitis A virus ",
            "Hepatitis B virus",
            "Hepatitis C virus/1/2/3/4/5/6",
            "Hepatitis D virus",
            "Hepatitis E virus",
            "Hepatitis G virus",
            "Human immunodeficiency virus/HIV-1/HIV-2",
            "Brucella",
            "Campylobacter (jejuni, coli, and upsaliensis)",
            "Listeria monocytogenes",
            "Proteus ",
            "Neospora caninum",
            "Cryptosporidiumn Tyzzer",
            "Ureaplasma Parvum",
            "Coxiella burnetii",
            "Dengue virus",
            "Borrelia burgdorferi",
            "Rickettsia",
            "Clostridium tetani",
            "Fusobacterium",
            "Variola virus",
            "Herpesviruses",
            "Herpes simplex virus type 1/2",
            "Varicella-zoster virus",
            "Epstein-Barr virus",
            "Human Herpesvirus 6/7/8",
            "Salmonella enterica",
            "Salmonella enterica paratyphoidfever",
            "Typhoid fever Salmonella typhi",
            "Shigella",
            "Shigella sonnei",
            "Leishmania leishmaniasis",
            "Ross River virus",
            "Langya virus",
            "Bacillus anthracis",
            "Corynebacterium diphtheriae",
            "BK polyomavirus Polyomaviridae ",
            "JC polyomavirus"
          ]
        },
        {
          key: "M",
          code: "Encephalitis",
          child: [
            "Japanese encephalitis virus",
            "Semliki Forest virus ",
            "Eastern equine encephalitis virus",
            "Venezuelan equine encephalitis virus",
            "Western equine encephalitis virus",
            "Saint Louis encephalitis virus",
            "Murray Valley encephalitis virus",
            "Montana myotis leukoencephalitis virus",
            "Luteimonas mephitis",
            "California encephalitis",
            "West Nile Virus ",
            "Escherichia coli K1",
            "Haemophilus influenzae",
            "Listeria monocytogenes",
            "Neisseria meningitidis",
            "Streptococcus agalactiae",
            "Streptococcus pneumoniae",
            "Enterovirus",
            "Herpes simplex virus 1/2",
            "Human herpesvirus 6",
            "Human cytomegalovirus",
            "Echovirus E30",
            "Nipah henipavirus",
            "Coxsackievirus A16/A6/A10",
            "Enterovirus A71 ",
            "Human parechovirus 1/2/3/4/5/6/7/8/9/10/11/12",
            "Cryptococcus neoformans/gattii",
            "Cronobacter"
          ]
        }
      ],
      actListItemKey: "A",
      sequenceFilter: [],
      schemeList: [
        "Prioritizing multicopy regions (for big genomes)",
        "Prioritizing specific regions (for small genomes)"
      ],
      typeList: [
        {
          label: "Target Species",
          value: 0
        },
        {
          label: "Comparison organisms",
          value: 1
        }
      ],
      genusOptions: getGenus(),
      targetSpeciesOptions: [],
      contrastSpeciesOptions: [],
      formData: {
        name: "",
        genus: "",
        strain: "",
        targetFragmentLength: 300,
        specificity: 80,
        repeatSimilarity: 80,
        hostSequence: ["No filtering"],
        priorityScheme: "",
        distribution: 80,
        similarityThreshold: "",
        isFile: false,
        targetStrainList: [
          {
            combination: ""
          }
        ],
        contrastStrainList: [
          {
            combination: ""
          }
        ],
        settings: "Default settings",
        primersLengthBegin: "",
        primersLengthEnd: "",
        primersTm: "",
        primersTmRange: "",
        ampliconLengthBegin: "",
        ampliconLengthEnd: "",
        probeLengthBegin: "",
        probeLengthEnd: "",
        probeTm: "",
        probeTmRange: ""
      },
      dataRule: {
        name: [
          {
            required: true,
            message: "Please enter Pipeline name",
            trigger: "blur"
          }
        ],
        genus: [
          { required: true, message: "Please select genus", trigger: "blur" }
        ],
        contrastStr: [
          {
            required: true,
            message: "Please enter Target Species",
            trigger: "blur"
          }
        ],
        targetStr: [
          {
            required: true,
            message: "Please enter Comparison organisms",
            trigger: "blur"
          }
        ],
        targetFragmentLength: [
          {
            required: true,
            message: "Please enter Target fragment length",
            trigger: "blur"
          }
        ],
        targetStrainList: [
          {
            required: true,
            message: "Please select Target specis/Target subspecies",
            trigger: "blur"
          }
        ],
        contrastStrainList: [
          {
            required: true,
            message: "Please select Comparison organisms",
            trigger: "blur"
          }
        ],
        specificity: [
          {
            required: true,
            message: "Please enter Species specificity",
            trigger: "blur"
          }
        ],
        repeatSimilarity: [
          {
            required: true,
            message: "Please enter Repeated region similarity",
            trigger: "blur"
          }
        ],
        hostSequence: [
          {
            required: true,
            message: "Please select Host sequence filtering",
            trigger: "change"
          }
        ],
        priorityScheme: [
          {
            required: true,
            message: "Please select Priority scheme",
            trigger: "change"
          }
        ],
        distribution: [
          {
            required: true,
            message: "Please enter Target fragment strain distribution",
            trigger: "blur"
          }
        ],
        similarityThreshold: [
          { required: true, message: "相似性报警阈值不能为空", trigger: "blur" }
        ],
        isFile: [
          { required: true, message: "上传本地文件不能为空", trigger: "change" }
        ]
      },
      dialogVisible: false,
      uploadForm: {
        wId: 0,
        // type: 0,
        strainName: " "
      },
      uploaded: [],
      fileList: [],
      fileList2: [],
      filterKey: "",
      dataList: [],
      paginations: {
        size: 5,
        page: 1,
        total: 0
      }
    };
  },
  computed: {
    uploadPath() {
      return this.$http.adornUrl(
        `/ga/workflow/upload?token=${this.$cookie.get("sw_token")}`
      );
    },
    actListItem() {
      return this.list.find(e => e.key === this.actListItemKey);
    }
  },
  watch: {
    $route: function(n) {
      this.setWindowHeight();
      this.$set(this.$data, "step", +n.query.flag);
      if (n.query.flag === "2") {
        window.scrollTo(0, 0);
        this.getDataList();
      }
    },
    "formData.settings": function(n) {
      if (n === "Default settings") {
        this.setDefaultSettings();
      }
    },
    "formData.hostSequence": function(n, o) {
      if (n.length) {
        if (n.includes("No filtering") && n.length > 1) {
          if (o.includes("No filtering")) {
            this.$set(
              this.formData,
              "hostSequence",
              n.filter(e => e !== "No filtering")
            );
          } else {
            this.$set(this.formData, "hostSequence", ["No filtering"]);
          }
        }
      } else {
        this.$set(this.formData, "hostSequence", ["No filtering"]);
      }
    },
    // 'formData.uploadType': function (n) {
    //   this.$set(this.uploadForm, 'type', n)
    // },
    "paginations.page": function() {
      this.getDataList();
    }
  },
  mounted() {
    this.$set(this.$data, "step", +this.$route.query.flag);

    this.setDefaultSettings();

    if (+this.$route.query.flag === 2) {
      this.getDataList();
    }

    this.$nextTick(() => this.setWindowHeight());

    this.targetSpeciesOptions = targetList();
  },
  methods: {
    setWindowHeight() {
      var wheight = window.innerHeight
        ? window.innerHeight
        : document.documentElement && document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : document.body.offsetHeight;

      var scrollHeight = document.documentElement
        ? document.documentElement.scrollTop
        : document.body.scrollTop;

      this.$set(
        this.$data,
        "mainHeight",
        wheight + scrollHeight - 102 - 48 + "px"
      );

      window.addEventListener(
        "resize",
        function() {
          var wheight = window.innerHeight
            ? window.innerHeight
            : document.documentElement && document.documentElement.clientHeight
            ? document.documentElement.clientHeight
            : document.body.offsetHeight;

          var scrollHeight = document.documentElement
            ? document.documentElement.scrollTop
            : document.body.scrollTop;

          this.$set(
            this.$data,
            "mainHeight",
            wheight + scrollHeight - 102 - 48 + "px"
          );
        }.bind(this)
      );
    },
    setDefaultSettings() {
      this.$set(this.$data, "formData", {
        ...this.formData,
        primersLengthBegin: 17,
        primersLengthEnd: 31,
        primersTm: 61.0,
        primersTmRange: 3.0,
        ampliconLengthBegin: 70,
        ampliconLengthEnd: 200,
        probeLengthBegin: 17,
        probeLengthEnd: 30,
        probeTm: 10.0,
        probeTmRange: 5.0
      });
    },
    toForm() {
      if (this.$cookie.get("sw_token")) {
        this.$router.push({ path: "/shine", query: { flag: 1 } });
      } else {
        this.$message({
          message: "Please log in",
          type: "warning",
          duration: 1500,
          onClose: () => {
            this.$router.push({ path: "/home" });
          }
        });
      }
    },
    // 获取数据列表
    getDataList() {
      // this.dataListLoading = true
      let { page, size } = this.paginations;
      this.$http({
        url: this.$http.adornUrl("/ga/workflow/list"),
        method: "get",
        params: this.$http.adornParams({
          page: page,
          limit: size,
          name: this.filterKey
        })
      }).then(({ data }) => {
        if (data && data.code === 0) {
          let { currPage, list, totalCount, pageSize } = data.page;
          this.dataList = list;
          this.$set(this.$data, "paginations", {
            size: pageSize,
            page: currPage,
            total: totalCount
          });
        } else {
          this.dataList = [];
        }
        // this.dataListLoading = false
      });
    },
    submitForm() {
      this.sb = true;
      this.$refs.form.validate(valid => {
        if (
          valid &&
          (!this.formData.isFile ||
            (this.formData.isFile &&
              (this.fileList.length || this.fileList2.length)))
        ) {
          // for (let i = 0; i < this.formData.targetStrainList.length; i++) {
          //   this.formData.targetStrainList[i].genus = this.formData.genus
          //    this.formData.targetStrainList[i].species = this.formData.targetStr
          // }
          // for (let i = 0; i < this.formData.contrastStrainList.length; i++) {
          //   this.formData.contrastStrainList[i].genus = this.formData.genus
          //   this.formData.contrastStrainList[i].species = this.formData.contrastStr
          // }
          this.$confirm("Please confirm the parameters and submit.", "Tips", {
            confirmButtonText: "confirm",
            cancelButtonText: "cancel",
            customClass: "shineTip",
            type: "warning"
          })
            .then(() => {
              this.$http({
                url: this.$http.adornUrl("/ga/workflow/save"),
                method: "post",
                data: this.$http.adornData({
                  ...this.formData,
                  name: this.formData.name,
                  targetFragmentLength: this.formData.targetFragmentLength,
                  specificity: this.formData.specificity,
                  repeatSimilarity: this.formData.repeatSimilarity,
                  hostSequence: this.formData.hostSequence.join(","),
                  priorityScheme: this.formData.priorityScheme,
                  distribution: this.formData.distribution,
                  similarityThreshold: this.formData.similarityThreshold,
                  targetStrainList: this.formData.targetStrainList.filter(
                    item => item.combination.length > 0
                  ),
                  contrastStrainList: this.formData.contrastStrainList.filter(
                    item => item.combination.length > 0
                  ),
                  isFile: this.formData.isFile ? "需要" : "不需要"
                })
              }).then(({ data }) => {
                if (data && data.code === 0) {
                  if (this.formData.isFile) {
                    this.uploadForm.wId = data.workflow.id;
                    this.uploadForm.status = data.workflow.status;
                    this.$message({
                      message: "Submitted successfully",
                      type: "success",
                      duration: 1500,
                      onClose: () => {
                        if (this.fileList.length) {
                          this.$refs.inputFile.submit();
                        }
                        if (this.fileList2.length) {
                          this.$refs.inputFile2.submit();
                        }
                      }
                    });
                  } else {
                    this.$router.push({ path: "/shine", query: { flag: 2 } });
                    // this.$refs.form.resetFields()
                    this.resetForm();
                    this.$message({
                      message: "Submitted successfully",
                      type: "success",
                      duration: 1500,
                      onClose: () => {
                        this.sb = false;
                      }
                    });
                  }
                } else {
                  // this.subDisabled = false
                  this.$message.error(data.msg);
                  this.sb = false;
                }
              });
            })
            .catch(() => {});
        } else {
          this.$message.warning("Select Upload file");
          this.sb = false;
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      Object.assign(this.formData, {
        targetStrainList: [
          {
            combination: ""
          }
        ],
        contrastStrainList: [
          {
            combination: ""
          }
        ]
      });
      this.uploaded = [];
      this.fileList = [];
      this.fileList2 = [];
      this.contrastSpeciesOptions = [];
    },
    // 下载
    downloadHandle(row) {
      if (row.status === "4") {
        // console.log(this.$http.adornUrl(`/ga/workflow/download?id=${row.id}&token=${this.$cookie.get('sw_token')}`))
        window.location.href = this.$http.adornUrl(
          `/ga/workflow/download?id=${row.id}&token=${this.$cookie.get(
            "sw_token"
          )}`
        );
      } else {
        this.$message.warning(
          "The calculation is not complete and cannot be downloaded!"
        );
      }
    },
    // 删除
    deleteHandle(row) {
      this.$confirm(`Confirm deletion?`, " ", {
        confirmButtonText: "yes",
        cancelButtonText: "no",
        type: "warning"
      })
        .then(() => {
          this.$http({
            url: this.$http.adornUrl("/ga/workflow/delete"),
            method: "post",
            data: this.$http.adornData(row.id, false)
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.getDataList();
                }
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {});
    },
    speciesDataFilter(val, index, type) {
      if (val) {
        if (type === 0) {
          this.targetSpeciesOptions[index] = this.speciesOptions.filter(
            item => {
              if (item.label.toUpperCase().indexOf(val.toUpperCase()) === 0) {
                return true;
              }
            }
          );
        } else {
          this.contrastSpeciesOptions[index] = this.speciesOptions.filter(
            item => {
              if (item.label.toUpperCase().indexOf(val.toUpperCase()) === 0) {
                return true;
              }
            }
          );
        }
      } else {
        if (type === 0) {
          this.targetSpeciesOptions[index] = this.speciesOptions;
        } else {
          this.contrastSpeciesOptions[index] = this.speciesOptions;
        }
      }
      this.$forceUpdate();
    },
    genusChangeHandle(value) {
      this.speciesOptions = getSpecies(value);
      for (let i = 0; i < this.formData.targetStrainList.length; i++) {
        this.formData.targetStrainList[i].species = "";
        this.targetSpeciesOptions[i] = this.speciesOptions;
      }
      for (let i = 0; i < this.formData.contrastStrainList.length; i++) {
        this.formData.contrastStrainList[i].species = "";
        this.contrastSpeciesOptions[i] = this.speciesOptions;
      }
      this.$forceUpdate();
    },
    changeHandle(file, fileList, field) {
      this.$set(this.$data, field, fileList);
      // this.fileList = fileList
    },
    removeHandle(file, fileList, field) {
      this.$set(this.$data, field, fileList);
      // this.fileList = fileList
    },
    beforeUploadHandle(file) {
      const validSize = file.size / 1024 / 1024 < 100;
      if (!validSize) {
        this.$message.warning(
          "The size of the uploaded file cannot exceed 100MB"
        );
      }
      return validSize;
    },
    successHandle(response, file, fileList, field) {
      this.$set(this.$data, field, fileList);
      if (response && response.code === 0) {
        // this.uploaded.push(fileList)
        this.uploaded = [...this.uploaded, ...fileList];
        // 最后一次上传成功 调用上传完毕接口
        if (
          this.uploaded.length === [...this.fileList, ...this.fileList2].length
        ) {
          this.$http({
            url: this.$http.adornUrl(`/ga/workflow/upload/finish`),
            method: "post",
            data: this.$http.adornData(this.uploadForm.wId, false)
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$router.push({ path: "/shine", query: { flag: 2 } });
              // this.$refs.form.resetFields()
              this.resetForm();
              this.$message({
                message: "File transfer successful. data saving",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.sb = false;
                }
              });
              // this.submitForm()
            } else {
              this.$message.error(response.msg || "Upload failed");
            }
          });
        }
      } else {
        this.$message.error(response.msg || "Upload failed");
      }
    },
    customColors(percentage) {
      if (+percentage === 100) {
        return "#67c23a";
      } else {
        return "#e6a23c";
      }
    },
    changeTargetStrain(index, val) {
      if (index === 0) {
        this.formData.targetStrainList = [
          {
            combination: val
          }
        ];
        this.contrastSpeciesOptions = [];
        this.formData.contrastStrainList = [
          {
            combination: ""
          }
        ];
        if (val) {
          this.contrastSpeciesOptions = this.targetSpeciesOptions.filter(
            item => item.split(">")[0] === val.split(">")[0]
          );
        }
      }
    }
  }
};
</script>

<style scoped>
.abstract {
  word-break: break-word;
  position: relative;
}
.abstract .title {
  font-size: 2rem;
  margin-bottom: 1.2rem;
}
.main {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url("../../static/img/background1.png") repeat;
  background-size: cover;
  overflow: hidden;
}
.b-title {
  font-size: 32px;
  line-height: 32px;
  letter-spacing: 1.5px;
  color: #efdbc4;
}
.b-content {
  height: 420px;
}
.b-content > * {
  position: relative;
}
.listBlock {
  width: 380px;
  height: 420px;
  z-index: 99;
  font-size: 16px;
  color: #221815;
  line-height: 27px;
  font-weight: bold;
}
.listBlock > div:hover {
  color: #7c8624;
  cursor: pointer;
}
.resTabIcon {
  position: absolute;
  font-size: 24px;
  font-weight: bold;
  color: white;
  width: 86px;
  height: 86px;
  left: -43px;
  top: -30px;
  background: url("../../static/img/star.png") no-repeat;
  background-size: 100% 100%;
}
.resTabTitle {
  color: white;
  padding: 8px 42px;
  font-size: 24px;
  letter-spacing: 1px;
  background: #084e4e;
  width: 360px;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.resTabContent {
  padding: 10px;
  text-align: left;
  border: 1px solid white;
  width: 360px;
  height: 360px;
  box-sizing: border-box;
  background: #dde2aa;
  overflow-y: auto;
  overflow-x: hidden;
}
.resTabContent > div {
  line-height: 26px;
  font-size: 14px;
  padding: 0 30px;
  letter-spacing: 0.5px;
  display: flex;
}
.customBtn {
  font-size: 18px;
  letter-spacing: 0.5px;
  cursor: pointer;
  border: 1px solid white;
  width: 260px;
  padding: 10px;
}
.blocks {
  width: 55%;
  min-width: 1020px;
  padding: 25px 25px;
}
.blockTitle {
  color: white;
  background: #492500;
  width: 210px;
  padding: 10px 0;
}
.block {
  color: #000;
  font-size: 13px;
  border: 1px solid white;
  background: #d2da87;
  padding: 25px;
  text-align: left;
  line-height: 24px;
}
.formBlock {
  border: 1px solid white;
  background: #d2da87;
  padding: 20px 25px;
  text-align: left;
  line-height: 24px;
  margin-top: 30px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formBlock > div {
  width: 45%;
}
.moreForm {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 10px;
  border-top: 1px dashed white;
  width: 100% !important;
}
.moreForm > div {
  width: 48%;
  margin-left: 0px !important;
}
.moreForm /deep/ .el-form-item__content {
  display: flex;
  width: 100%;
}
.extForm {
  padding: 0 10px;
}
.extForm > div .el-form-item {
  width: 35% !important;
  margin-right: 20px;
}
/*.extForm > div .el-form-item {*/
/*  width: 40% !important;*/
/*}*/
.greenTitle {
  color: #7c8624;
  font-size: 18px;
}
.tableIcon {
  margin: 5px;
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  color: white;
  border-radius: 50%;
  cursor: pointer;
  align-items: center;
  background: #b2bd52;
  border: 2px solid white;
  box-shadow: 0 8px 5px #728108;
  transition: all 0.1s;
}
.tableIcon:hover {
  transform: scale(1.05);
}
* /deep/ .customDialog {
  background: #b1bb5c;
  border: 1px solid white;
}

* /deep/ .customInp-small input {
  background: #939d31;
  margin: 5px 0;
  box-shadow: 0 8px 5px #728108;
  border: 2px solid white;
  color: black;
  font-size: 13px;
  color: white;
  height: 32px;
  line-height: 32px;
  border-radius: 15px;
}

* /deep/ .customInp-mini input {
  width: 50px;
  background: #b2bd52;
  box-shadow: 0 8px 5px #728108;
  border: 2px solid white;
  color: black;
  font-size: 13px;
  color: white;
  height: 24px;
  line-height: 24px;
  border-radius: 15px;
}

* /deep/ .white input {
  color: #fff !important;
}

* /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #9ca63e;
  border-color: #9ca63e;
}

* /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #9ca63e;
}

* /deep/ .el-form-item {
  margin-bottom: 3px;
  width: 100%;
}

* /deep/ .el-form-item label {
  color: #492500 !important;
}

* /deep/ .el-upload-dragger {
  background: #cfd782;
  border: 1px solid white;
}

* /deep/ .el-checkbox__inner:hover {
  border-color: #9ca63e;
}

* /deep/ .el-checkbox__inner.is-focus {
  border-color: #9ca63e;
}

* /deep/ .el-select .el-input.is-focus .el-input__inner {
  /*border-color: #9CA63E*/
}
* /deep/ .el-select .el-input__inner:focus {
  border-color: #fff;
}

* /deep/ .el-table {
  border-top-width: 0.5px;
}

* /deep/ .el-table tbody tr:hover > td {
  background: #d3dc8d !important;
}

* /deep/ .el-table th:nth-child(odd),
* /deep/ .el-table td:nth-child(odd) {
  background: #e2e9a4;
}
* /deep/ .el-table th:nth-child(even),
* /deep/ .el-table td:nth-child(even) {
  background: #d3dc8d;
}
* /deep/ .el-table__empty-block {
  background: #e2e9a4;
}
* /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #939d31;
  color: white !important;
}
* /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #9ca63e;
}
* /deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #939d31;
}
* /deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #939d31;
  background: #939d31;
}

* /deep/ .el-select .el-input .el-select__caret {
  color: #fff;
  padding: 0 6px;
  background: #492500;
  height: 27.5px;
  margin-right: -4px;
  line-height: 27.5px;
  margin-top: 7.5px;
  transition: 0s;
}

* /deep/ .el-input__suffix i {
  top: 1px;
  margin-right: -5px;
  border-radius: 30px 0 0 30px;
}

* /deep/ .el-select .el-input .el-select__caret.is-reverse {
  border-radius: 0 30px 30px 0;
}

* /deep/ .el-input.is-disabled .el-input__inner {
  background-color: #b1be54;
  border-color: #e4e7ed;
  color: #eee;
}
</style>
<style>
.shineTip * .el-button--primary {
  background: #929d34;
  border-color: #929d34;
}
</style>



// WEBPACK FOOTER //
// src/components/shine.vue